import Overview from './overview.vue';
import Full from './full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
